/**
 * Notification module.
 * Used for displaying dynamic/interactive success and error messages to the user.
 *
 * WARNING: This JS may not be served by the same service as the one which serves
 * HTML/CSS which this JS depends on. E.g. this JS may be served by a BabyStorm
 * while the HTML/CSS may be served by Storm. Take care when updating this JS or any
 * related HTML/CSS.
 * See https://wiki.yext.to/index.php/Postmortem:IN-1085_Capacity_Limit_Exceeded_Modal_in_Customer_Portal#Root_causes
 * for context.
 *
 * @author Billy Bastardi (billy@yext.com)
 */
goog.provide('yext.notify');

// A local cache reference to the notify wrapper HTML node used for our toast

goog.require('yext');

yext.notify.$notifyMessage = undefined;

/**
 * Initialize our module
 * @deprecated Use ui/components/toast instead
 */
yext.notify.init = function() {
  yext.notify.$notifyMessage = $('.notify-toast-message');
  yext.notify.bindDismiss();
};
goog.exportSymbol('yext.notify.init', yext.notify.init);

/**
 * Attaches an onclick event to success messages to make them fade.
 * @deprecated Use ui/components/toast instead
 */
yext.notify.bindDismiss = function() {
  yext.notify.$notifyMessage.on('click', '.notify-dismiss', yext.notify.hide);
};

/**
 * Sets a success message class on the toast msg and then displays it
 * @param {string} msg The message to display
 * @param {number=} opt_delay How long before hiding the success message (default 0)
 * @deprecated Use ui/components/toast instead
 */
yext.notify.showSuccess = function(msg, opt_delay) {
  yext.notify.showMessage(msg, opt_delay, 'block-success');
};
goog.exportSymbol('yext.notify.showSuccess', yext.notify.showSuccess);

/**
 * Sets a success message class on the toast msg and then displays it
 * @param {string} msg The message to display
 * @param {number=} opt_delay How long before hiding the success message (default 0)
 * @deprecated Use ui/components/toast instead
 */
yext.notify.showWarning = function(msg, opt_delay) {
  yext.notify.showMessage(msg, opt_delay, 'block-warning');
};
goog.exportSymbol('yext.notify.showWarning', yext.notify.showWarning);

/**
 * Sets a warning message class on the toast msg and then displays it
 * @param {string} msg The message to display
 * @param {number=} opt_delay How long before hiding the error message (default 0)
 * @deprecated Use ui/components/toast instead
 */
yext.notify.showError = function(msg, opt_delay) {
  yext.notify.showMessage(msg, opt_delay, 'block-error');
};
goog.exportSymbol('yext.notify.showError', yext.notify.showError);

/**
 * Sets a styling class on the toast msg (defaults to block) and then displays it
 * @param {string} msg The message to display
 * @param {number=} opt_delay How long before hiding the error message (default 0)
 * @param {string} styling_class CSS style class for given warning types
 * @deprecated Use ui/components/toast instead
 */
yext.notify.showMessage = function(msg, opt_delay, styling_class) {
  styling_class = styling_class || 'block';

  yext.notify.$notifyMessage
    .removeClass('block block-success block-warning block-error')
    .addClass(styling_class);

  yext.notify.show(msg, opt_delay);
};

/**
 * Handle hiding the success message
 * @param {number=} opt_delay How long before hiding the success message (defaults to 0)
 * @deprecated Use ui/components/toast instead
 */
yext.notify.hide = function(opt_delay) {
  // If delay is 0, kill the fx que and hide it
  if (typeof opt_delay !== 'number' || opt_delay === 0) {
    yext.notify.$notifyMessage
      .stop(true)
      .slideUp();

    return;
  }

  yext.notify.$notifyMessage
    .delay(opt_delay)
    .slideUp('fast');
};

/**
 * Handles showing the success message animation
 * @param {number=} opt_delay How long before hiding the success message (default 0)
 * @deprecated Use ui/components/toast instead
 */
yext.notify.show = function(msg, opt_delay) {
  opt_delay = opt_delay || 10000;

  yext.notify.$notifyMessage
    .find('.notify-msg-text')
    .html(msg).end()
    .slideDown('fast');

  yext.notify.hide(opt_delay);
};

/**
 * Handles addition of the appropriate class and showing the escaped
 * message with animation
 * @param {number=} opt_delay How long before hiding the success message (default 0)
 * @deprecated Use ui/components/toast instead
 */
yext.notify.showText = function(msg, opt_delay, styling_class) {
  opt_delay = opt_delay || 10000;

  styling_class = styling_class || 'block';

  yext.notify.$notifyMessage
    .removeClass('block block-success block-warning block-error')
    .addClass(styling_class);

  yext.notify.$notifyMessage
    .find('.notify-msg-text')
    .text(msg).end()
    .slideDown('fast');

  yext.notify.hide(opt_delay);
};

/**
 * @deprecated
 * TODO: Remove this and showText() above
 *
 * Searches for URL parameters indicating a toast message. If found, displays the
 * message with any provided delay and status values. Removes the toast parameters
 * from URL via window.history.replaceState() (works only IE10+)
 */
yext.notify.showUrlMessage = function() {
  var params = yext.getUrlParams();

  if (params['toastMessage']) {
    var message = window.decodeURI(params['toastMessage']);
    var delay = parseInt(params['toastDelay']) || undefined;

    switch (params['toastStatus']) {
      case 'error':
        yext.notify.showText(message, delay, 'block-error');
        break;
      case 'success':
        yext.notify.showText(message, delay, 'block-success');
        break;
      case 'warning':
        yext.notify.showText(message, delay, 'block-warning');
        break;
      default:
        yext.notify.showText(message, delay, undefined);
    }

    // removes toastParameters via HTML5 replaceState() (IE10+ only)
    if (window.history && window.history.replaceState) {
      delete params['toastMessage'];
      delete params['toastDelay'];
      delete params['toastStatus'];

      // replace current URL with the same URL minus the above-removed parameters
      $(window).on('load', function() {
        window.history.replaceState(
          {},
          document.title,
          yext.serializeUrl(window.location.href.split('?')[0], params),
        );
      });
    }
  }
};
goog.exportSymbol('yext.notify.showUrlMessage', yext.notify.showUrlMessage);
